import { createDDSClient } from "@aelive/dds-client";

// NO Authorization HEADER HERE, deliberately.
//
// Org-scoped queries do still need the caller's token to reach
// AeroBackend.User-Management-Service's authenticated /organization/:id — but it
// travels in the GraphQL `context` of the request BODY, not as an HTTP header:
//
//   dds.getStaticData({ keys, context: { org_id, token: `Bearer ${t}` } })
//
// BB_DataDistributionService reads it there (graphql/resolvers/query.resolvers.js
// destructures `token` off `context`) and sets Authorization itself on its own
// outbound calls to UMS and DWS (modules/org/orgAccess.js, modules/query/dwsClient.js).
// Its Apollo context is only `{ headers: req.headers }` and no resolver reads
// `headers.authorization`, so a header sent from here is never looked at.
//
// It is not merely redundant, it actively breaks the page: the CloudFront
// distributions in front of DDS drop the CORS response headers on any preflight
// whose Access-Control-Request-Headers includes `authorization` (confirmed on
// dev and tst; the origin ALB answers correctly, so it is a CDN policy). The
// browser then reports "No 'Access-Control-Allow-Origin' header" and every DDS
// call from this page fails. `content-type` alone, and arbitrary `x-*` headers,
// pass through fine.
//
// So: pass the token per call in `context`, never here. If a future caller needs
// header auth, the CloudFront policy has to allow `authorization` first.
export const dds = createDDSClient({
  http: { url: process.env.REACT_APP_DDS_HTTP_URL },
  ws: { url: process.env.REACT_APP_DDS_WS_URL },
});
